import React from 'react';

const About = () => {
  return (
    <div className='flex flex-col justify-center items-center min-h-96'>
      <div className=''>
        <h1
          className='text-4xl mb-2'
          style={{ fontFamily: "'Teko', sans-serif" }}
        >
          <span className='text-yellow-500'>The</span>
          <span className='text-black'>Champs</span>
        </h1>
        <p className='text-xs text-gray-500 mb-8'>v0.0.1 (PWA)</p>

        <p className='font-bold'>Dx2 Project Co.</p>

        <p className='text-xs mb-2'>
          <a
            href='https://web.thechamps.app/legal/privacy-policy.html'
            target='_blank'
            rel='noopener noreferrer'
          >
            Privacy Policy
          </a>
          {' | '}
          <a
            href='https://web.thechamps.app/legal/terms.html'
            target='_blank'
            rel='noopener noreferrer'
          >
            Terms of Service
          </a>
        </p>
        <p className='text-xs text-gray-500'>
          Copyright © 2025 Dx2Project. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default About;
